import React, { useEffect, useRef, useState } from 'react';

import classNames from 'classnames';
import { motion } from 'framer-motion';

interface AnimateChangeInHeightProps {
  children: React.ReactNode;
  className?: string;
}

export const AnimateChangeInHeight: React.FC<AnimateChangeInHeightProps> = ({ children, className }) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [height, setHeight] = useState<number | 'auto'>('auto');

  useEffect(() => {
    if (containerRef.current) {
      const resizeObserver = new ResizeObserver((entries) => {
        const observedHeight = entries[0].contentRect.height;
        setHeight(observedHeight);
      });

      resizeObserver.observe(containerRef.current);

      return () => {
        resizeObserver.disconnect();
      };
    }
  }, []);

  return (
    <motion.div
      className={classNames(className, 'overflow-hidden')}
      style={{ height, minWidth: '100%' }}
      animate={{ height }}
      transition={{
        type: 'spring',
        stiffness: 120,
        damping: 16,
      }}
    >
      <div ref={containerRef}>{children}</div>
    </motion.div>
  );
};
